import React, { useState, useEffect } from "react";
import PatientDataService from "../services/patient.service";
import AdminDataService from "../services/admin.service";
import { useAuth0 } from '@auth0/auth0-react';
import 'bootstrap/dist/css/bootstrap.css'; 
import ProfileModal from "./profile-modal.component";

const ConfirmRdv = () => {
  const { getAccessTokenSilently, user } = useAuth0();
  
  const [showProfileModal, setShowProfileModal] = useState(false);

  const [state, setState] = useState({
    infordv: [],
    drdv: '',
    jrdv: '',
    hdrdv: '',
    plann: '',
    moyen_paiement: '',
    airtel_num: '',
    moov_num: '',
    showAirtelTip: false,
    showMoovTip: false,
    payBusy: false,
    payError: '',
    confirmOk: false,
    nom: '',
    nbr_canceled_rdv: null,
    weekDay: {"1":"Dimanche","2":"Lundi","3":"Mardi","4":"Mercredi","5":"Jeudi","6":"Vendredi","7":"Samedi"},
    months: {"01":"Janvier","02":"Février","03":"Mars","04":"Avril","05":"Mai","06":"Juin","07":"Juillet","08":"Août","09":"Septembre","10":"Octobre","11":"Novembre","12":"Décembre"} 
  });

  const getNomPatient = async () => {
    try {
      const res = await AdminDataService.getUserNameByEmail(user.email);
      const p = res?.data || null;
      if (!p || !p.nom || String(p.nom).trim() === "") {
        setShowProfileModal(true);
        return;
      }
      const fullName = [p.nom, p.prenom].filter(Boolean).join(' ').trim();
      setState(prev => ({
        ...prev,
        nom: fullName
      }));
    } catch (e) {
      // En cas d'erreur, forcer l'ouverture du modal pour compléter le profil
      setShowProfileModal(true);
    }
  };

  const getInfoRdv = async (idplann, drdv) => {
    try {
      const response = await PatientDataService.showConfirm(idplann, drdv);
      setState(prev => ({
        ...prev,
        infordv: response.data[0],
        hdrdv: response.data[0].heure_debut
      }));
    } catch (e) {
      console.log(e);
    }
  };

  const getCanceledRdv = async (idplann) => {
    try {
      const response = await PatientDataService.canceledRdv(idplann, user.email);
      setState(prev => ({
        ...prev,
        nbr_canceled_rdv: response.data[0].canceled_rdv
      }));
    } catch (e) {
      console.log(e);
    }
  };

  const onClickSelectMoyen = (moyen) => {
    setState(prev => ({
      ...prev,
      moyen_paiement: moyen,
      // Initialize and gray out the opposite input by clearing its value
      airtel_num: moyen === 'moov' ? '' : prev.airtel_num,
      moov_num: moyen === 'airtel' ? '' : prev.moov_num
    }));
  };

  useEffect(() => {
    const initializeComponent = async () => {
      try {
        const token = await getAccessTokenSilently({
          audience: process.env.REACT_APP_AUTH0_AUDIENCE,
          scope: "openid profile email"
        });
        
        // Configurer le token pour axios
        const http = require("../http-common").default;
        http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        
        const path = window.location.pathname.split('/');
        const param = path[path.length - 1];
        const idplann = param.split('&')[1];
        const drdv = param.split('&')[0];
        const jrdv = new Date(param.split('&')[0]).getDay() + 1;
        
        getNomPatient();
        getInfoRdv(idplann, drdv);
        getCanceledRdv(idplann);
        
        setState(prev => ({
          ...prev,
          drdv: drdv,
          jrdv: jrdv,
          plann: idplann
        }));
      } catch (error) {
        console.error('Erreur récupération token:', error);
      }
    };

    initializeComponent();
  }, [getAccessTokenSilently, user]);

  const { infordv, weekDay, months, drdv, jrdv, hdrdv, plann, moyen_paiement, nom, nbr_canceled_rdv, airtel_num, moov_num, showAirtelTip, showMoovTip, payBusy, payError, confirmOk } = state;

  const airtelRe = /^(?:241)(?:74|76|77)\d{6}$/;
  const moovRe = /^(?:241)(?:60|62|65|66)\d{6}$/;
  const isAirtelValid = airtelRe.test(String(airtel_num || '').replace(/\s+/g, ''));
  const isMoovValid = moovRe.test(String(moov_num || '').replace(/\s+/g, ''));
  const canConfirm = (moyen_paiement === 'airtel' && isAirtelValid) || (moyen_paiement === 'moov' && isMoovValid);

  const handleConfirm = async (e) => {
    e?.preventDefault?.();
    if (payBusy || confirmOk) return;
    setState(prev => ({ ...prev, payError: '', payBusy: true }));
    try {
      const free = Number(nbr_canceled_rdv) !== 0;
      if (!free) {
        const phone = moyen_paiement === 'airtel' ? airtel_num : moov_num;
        const sim = await PatientDataService.simulatePayment({ phone });
        if (!sim?.data?.success) {
          setState(prev => ({ ...prev, payError: 'Le paiement a échoué. Veuillez réessayer.' }));
          return;
        }
      }
      await PatientDataService.confirmRdvAfterPayment({ drdv, plann, email: user.email, free });
      setState(prev => ({ ...prev, confirmOk: true }));
    } catch (err) {
      setState(prev => ({ ...prev, payError: 'Une erreur est survenue lors de la confirmation.' }));
    } finally {
      setState(prev => ({ ...prev, payBusy: false }));
    }
  };

  return (
    <div className="col-md-12 mx-auto">
        {showProfileModal && (
          <ProfileModal
            isOpen={showProfileModal}
            email={(user?.email || '').trim()}
            onSaved={async () => {
              setShowProfileModal(false);
              await getNomPatient();
            }}
          />
        )}
        <div className="row mx-auto" style={{ backgroundColor: "#6f42c1", color: "white", padding: "20px" }}>
          <span style={{ fontSize: "1.5rem" }} className="lead"><b>Confirmation d'un rendez-vous</b></span>
        </div>
        <div className="row mx-auto g-2" style={{ backgroundColor: "#E6EAF7", padding: "40px" }}>
          <div className="col-md-6" style={{ backgroundColor: "white", padding: "40px" }}>
            <span style={{ fontSize: "1.5rem" }} className="lead"><b>Prestation</b></span>
            <hr></hr>
            <ul className="list-unstyled">
              <li className="lead">{nom}</li>
              <li className="lead">{infordv.libelle_structure}</li>
              <li className="lead">{infordv.titre + ' ' + infordv.nom + ' ' + infordv.prenom}</li>
              <li className="lead">{infordv.list_spec}</li>
              <li className="lead">{infordv.libelle_prestation}</li>
              <li className="lead">{weekDay[jrdv] + ' ' + drdv.split('-')[2] + ' ' + months[drdv.split('-')[1]] + ' ' + drdv.split('-')[0] + ' à partir de ' + hdrdv.split(':')[0] + 'h' + hdrdv.split(':')[1]}</li>
              <li className="lead">{'Patient N° ' + infordv.nbr_patient + ' / ' + infordv.max_patient}</li>
              <li className="lead">{'Tarif ' + infordv.prix + ' FCFA'}</li>
              <li className="lead">{infordv.list_ass}</li>
            </ul>
          </div>
          <div className="col" style={{ backgroundColor: "White", padding: "40px" }}>
            <span style={{ fontSize: "1.5rem" }} className="lead"><b>Règlement</b></span>
            <hr></hr>
            {typeof nbr_canceled_rdv === 'number' && (
              nbr_canceled_rdv === 0 ? (
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td colSpan={3}>
                        <ul className="list-unstyled">
                          <li className="lead">
                            Veuillez vous acquitter d'un montant de 2 000 FCFA pour confirmer votre rendez-vous.
                          </li>
                          {payError && (
                            <div className="alert alert-danger py-2 px-3 mb-0" role="alert">
                              <small>{payError}</small>
                            </div>
                          )}
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input className="form-check-input" type="radio" name="moyen" value="airtel" onClick={e => onClickSelectMoyen(e.target.value)} />
                      </td>
                      <td>
                        <img src="/airtel.png" alt="" width="80" height="80" />
                      </td>
                      <td>
                        <div className="position-relative">
                          <input
                            className="form-control form-control-lg"
                            type="text"
                            placeholder="Votre numéro Airtel Money"
                            value={airtel_num}
                            onChange={(e) => {
                              const digits = (e.target.value || '').replace(/\D/g, '');
                              setState(prev => ({ ...prev, airtel_num: digits }));
                            }}
                            onFocus={() => setState(prev => ({ ...prev, showAirtelTip: true }))}
                            onBlur={() => setState(prev => ({ ...prev, showAirtelTip: false }))}
                            disabled={moyen_paiement !== 'airtel'}
                            pattern="(?:241)(?:74|76|77)\d{6}"
                            inputMode="numeric"
                            maxLength={11}
                          />
                          {showAirtelTip && (
                            <div
                              className="alert alert-info d-flex align-items-center py-2 px-3 mb-0 position-absolute start-0 shadow"
                              role="alert"
                              style={{ top: '100%', marginTop: '0.25rem', zIndex: 1050, maxWidth: '100%' }}
                            >
                              <span className="small me-2">Format: 241 suivi de 74, 76 ou 77 puis 6 chiffres. Ex: 24177000000</span>
                              <button
                                type="button"
                                className="btn-close btn-sm ms-auto"
                                aria-label="Fermer"
                                onClick={() => setState(prev => ({ ...prev, showAirtelTip: false }))}
                              ></button>
                            </div>
                          )}
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <input className="form-check-input" type="radio" name="moyen" value="moov" onClick={e => onClickSelectMoyen(e.target.value)} />
                      </td>
                      <td>
                        <img src="/moov.png" alt="" width="80" height="80" />
                      </td>
                      <td>
                      <div className="position-relative">
                        <input
                            className="form-control form-control-lg"
                            type="text"
                            placeholder="Votre numéro Moov Money"
                            value={moov_num}
                            onChange={(e) => {
                              const digits = (e.target.value || '').replace(/\D/g, '');
                              setState(prev => ({ ...prev, moov_num: digits }));
                            }}
                            onFocus={() => setState(prev => ({ ...prev, showMoovTip: true }))}
                            onBlur={() => setState(prev => ({ ...prev, showMoovTip: false }))}
                            disabled={moyen_paiement !== 'moov'}
                            pattern="(?:241)(?:60|62|65|66)\d{6}"
                            inputMode="numeric"
                            maxLength={11}
                          />
                          {showMoovTip && (
                            <div
                              className="alert alert-info d-flex align-items-center py-2 px-3 mb-0 position-absolute start-0 shadow"
                              role="alert"
                              style={{ top: '100%', marginTop: '0.25rem', zIndex: 1050, maxWidth: '100%' }}
                            >
                              <span className="small me-2">Format: 241 suivi de 60, 62, 65 ou 66 puis 6 chiffres. Ex: 24160000000</span>
                              <button
                                type="button"
                                className="btn-close btn-sm ms-auto"
                                aria-label="Fermer"
                                onClick={() => setState(prev => ({ ...prev, showMoovTip: false }))}
                              ></button>
                            </div>
                          )}
                      </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan='3' align="center">
                        {confirmOk ? (
                          <div className="alert alert-success mb-0" role="alert">
                            Votre rendez-vous est confirmé.
                          </div>
                        ) : (
                          <button className="btn btn-outline-info" type="button" onClick={handleConfirm} disabled={!canConfirm || payBusy}>
                            {payBusy ? 'Veuillez patienter…' : 'Confirmer'}
                          </button>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              ) : (
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td colSpan={3}>
                        <ul className="list-unstyled">
                          <li className="lead">
                            <b>
                              Un précédent rendez-vous pour cette prestation avait été annulé. Le présent rendez-vous ne vous sera donc pas facturé. Veuillez confirmer!
                            </b>
                          </li>
                        </ul>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan='3' align="center">
                        {confirmOk ? (
                          <div className="alert alert-success mb-0" role="alert">
                            Votre rendez-vous est confirmé.
                          </div>
                        ) : (
                          <button className="btn btn-outline-info" type="button" onClick={handleConfirm} disabled={payBusy}>
                            {payBusy ? 'Veuillez patienter…' : 'Confirmer'}
                          </button>
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              )
            )}
          </div>

        </div>
      </div>
  );
};

export default ConfirmRdv;